import { render, staticRenderFns } from "./LandownerPayment.vue?vue&type=template&id=78caa5d0"
import script from "./LandownerPayment.vue?vue&type=script&lang=js"
export * from "./LandownerPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports